module.exports = __webpack_public_path__ + "static/img/face.a5a86499.png";